import * as React from "react";
import { WSErrorContainer } from "./WSErrorContainer";

export const WSErrorContainerContext =
  React.createContext<WSErrorContainer>(null);
